import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MonkeyBackdrop from "../../components/MonkeyBackdrop";
import "./intro.css";

const SAMPLE_CARDS = [
  { id: 1, text: "I can solve a Rubik's cube in under a minute", result: "Truth" },
  { id: 2, text: "I hate pizza", result: "Lie" },
  { id: 3, text: "I've traveled to another country", result: "Truth" },
  { id: 4, text: "I've met a celebrity", result: "Truth" },
  { id: 5, text: "I've never used Instagram", result: "Lie" },
  { id: 6, text: "I love waking up early", result: "Lie" },
  { id: 7, text: "I can swim", result: "Truth" },
  { id: 8, text: "I've never watched a movie in a theatre", result: "Lie" },
  { id: 9, text: "I drink coffee every day", result: "Truth" },
  { id: 10, text: "I've never eaten street food", result: "Lie" },
];

function Intro({ updateHeader }) {
  const navigate = useNavigate();
  
  useEffect(() => {
    updateHeader({
      backButtonRedirect: "/login?save=true",
      // ...(companyLogo ? { imageUrl: companyLogo } : {}),
    });
  }, []);

  return (
    <main className="intro">
      <MonkeyBackdrop />
      <div className="intro__decor" aria-hidden>
        <span className="intro__emoji intro__emoji--tl">😊</span>
        <span className="intro__emoji intro__emoji--tr">😢</span>
        <span className="intro__emoji intro__emoji--bl">😊</span>
        <span className="intro__emoji intro__emoji--br">😢</span>
      </div>

      <header className="intro__head">
        <h1 className="intro__title">Truth &amp; Trick</h1>
        <p className="intro__tagline">
          Either you&apos;ll get to know &apos;em better or you&apos;ll develop
          trust issues. Either way, you&apos;ll have a ton of fun!
        </p>
      </header>

      <div className="intro__cards-marquee">
        <div className="intro__cards-track">
          {[...SAMPLE_CARDS, ...SAMPLE_CARDS].map((card, index) => {
            const n = SAMPLE_CARDS.length;
            const waveIndex = index % n;
            const waveY = [14, -6, -22, -10, 18, -4, -16][waveIndex] ?? 0;
            const isDuplicate = index >= n;
            return (
              <div
                key={`${card.id}-${index}`}
                className={`intro__card-slot${isDuplicate ? " intro__card-slot--dup" : ""}`}
              >
                <div className="intro__card-slot-flip">
                  <div className="intro__card-slot__face intro__card-slot__face--front">
                    <article
                      className="intro__card intro__card--anim"
                      style={{
                        "--intro-wave-y": `${waveY}px`,
                        animationDelay: `${-(index * 0.42)}s`,
                      }}
                    >
                      <div className="intro__card-label">Two truth &amp; Lie</div>
                      <p className="intro__card-text">{card.text}</p>
                    </article>
                  </div>
                  <div className="intro__card-slot__face intro__card-slot__face--back">
                    <span className="intro__card-slot__reveal">
                      {card.result}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <Link
        to="/rules"
        className="intro__play begin-play-btn"
      >
        Ready
      </Link>
    </main>
  );
}

export default Intro;
